module.exports = __webpack_public_path__ + "img/9788963860046.c9d03f63.jpg";